import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { ReduxFeature } from 'Common/utils';
import * as features from './features';

const middleware = [thunk];

const sets = window.__LOCALIZATION_STRING_SETS__ || [];
const preloadedStrings = Object.assign({}, ...sets);

const featureOverrides = {
    localization: ReduxFeature.extend(features.localization, {
        initialState: {
            ...(features.localization?.initialState || {}),
            strings: preloadedStrings,
            ready: true,
        },
    }),
};

const finalFeatures = {
    ...features,
    ...featureOverrides,
};

const reducer = combineReducers(
    Object.keys(finalFeatures).reduce(
        (reducerMap, key) => ({
            ...reducerMap,
            [key]: ReduxFeature.getReducer(finalFeatures[key]),
        }),
        {}
    )
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })
    : compose;

export default createStore(reducer, composeEnhancers(applyMiddleware(...middleware)));
